import React from 'react';
// Images
import SexImage from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots-on-throne.jpg';
import WrestlingImage from '../../assets/images/main/mistress-md-professional-dominatrix-wrestling.avif';
import SploshingImage from '../../assets/images/main/mistress-md-professional-dominatrix-sploshing.avif';
// Constants
import {
  DOMINATION_PAGE_URL,
  SPLOSHING_PAGE_URL,
  WRESTLING_PAGE_URL,
} from '../../utils/Constants';

const items = [
  {
    id: 1,
    title: 'BDSM',
    subtitle:
      'Explore the world of dominance and submission in my personal chamber.',
    image: SexImage,
    link: DOMINATION_PAGE_URL,
  },
  {
    id: 2,
    title: 'WRESTLING',
    subtitle:
      'Experience the thrill of physical power and control in my exclusive wrestling sessions.',
    image: WrestlingImage,
    link: WRESTLING_PAGE_URL,
  },
  {
    id: 3,
    title: 'SPLOSHING',
    subtitle:
      'Indulge in messy, wet, and wild fun—sensory play taken to the next level.',
    image: SploshingImage,
    link: SPLOSHING_PAGE_URL,
  },
];

function HomeServicesSection() {
  return (
    <section className='grid w-full'>
      <div className='grid px-8 sm:px-10 md:px-16 lg:container lg:mx-auto'>
        <div className='mb-6 text-center'>
          <h4 className='font-StencilW01 text-3xl lg:text-5xl text-colour5 dark:text-colour5'>
            Explore More
          </h4>
          <h5 className='font-StencilW01 text-xl lg:text-2xl text-colour5 dark:text-colour5'>SESSIONS AND SERVICES</h5>
        </div>
        <section className='grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-8'>
          {items.map((item, index) => (
            <a
              href={item.link}
              key={item.id}
              className='border-b-2 grid grid-rows-rev pb-4 border-solid border-colour2 dark:border-colour1'
            >
              <div
                className={`p-2 grid h-full shadow-cardShadowBold ${
                  index === 0
                    ? 'bg-colour4'
                    : index === 1
                    ? 'bg-colour5'
                    : index === 2
                    ? 'bg-colour6'
                    : ''
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className='w-full h-full object-cover max-h-[70vh]'
                  loading='lazy'
                />
              </div>
              <div className='grid pt-4 gap-2 h-fit'>
                <h5 className='font-StencilW01 text-3xl text-colour5 dark:text-colour5 font-semibold'>
                  {item.title}
                </h5>
                <p className='play-subtitle'>{item.subtitle}</p>
              </div>
            </a>
          ))}
        </section>
      </div>
    </section>
  );
}

export default HomeServicesSection;
